import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startedAt"]

  prepare(event) {
    const startedAt = event.relatedTarget?.dataset?.quickWorkoutStartedAt
    if (!startedAt || !this.hasStartedAtTarget) return

    this.startedAtTarget.value = startedAt
  }
}
